export const TIMER_TICK="app/timer/TIMER_TICK"
